




















































































import Vue, { PropType } from "vue";
import { computed, onBeforeUnmount, onMounted, ref } from "@vue/composition-api";
import GaIcon from "../../card-items/GaIcon.vue";
import { useGenAiPalette } from "../../data/design";

export interface SelectOption {
  value: string;
  label: string;
}

export default Vue.extend({
  components: { GaIcon },
  props: {
    label: { type: String, default: "" },
    value: { type: String, required: true },
    options: { type: Array as PropType<SelectOption[]>, required: true },
    min_width: { type: String, default: "176px" },
    /** a value the drill-down fixed: shown, with a lock, and not offered */
    locked: { type: Boolean, default: false },
    /**
     * How a locked field reads, as gen-ai-ui has it: the pinned category is a
     * normal field with a lock ("plain"), a pinned activity is greyed out
     * ("muted").
     */
    locked_style: { type: String, default: "muted" },
  },
  setup(props, { emit }) {
    const T = useGenAiPalette();
    const root = ref<HTMLElement | null>(null);
    const open = ref(false);

    const selected_label = computed(() => {
      const found = (props.options as SelectOption[]).find((o) => o.value === props.value);
      return found ? found.label : props.value;
    });

    const pick = (value: string) => {
      emit("change", value);
      open.value = false;
    };

    const on_outside = (e: MouseEvent) => {
      if (open.value && root.value && !root.value.contains(e.target as Node)) {
        open.value = false;
      }
    };
    onMounted(() => document.addEventListener("mousedown", on_outside));
    onBeforeUnmount(() => document.removeEventListener("mousedown", on_outside));

    const muted = computed(() => props.locked && props.locked_style === "muted");

    const field = computed(() => ({
      gap: "8px",
      height: "34px",
      padding: "0 10px",
      minWidth: props.min_width,
      background: muted.value ? T.value.ev.inputDisabledBg : T.value.ev.inputBg,
      border: "1px solid " + T.value.ev.inputBorder,
      borderRadius: "6px",
      cursor: muted.value ? "not-allowed" : props.locked ? "default" : "pointer",
      opacity: muted.value ? 0.7 : 1,
      "--ga-field-hover": props.locked ? T.value.ev.inputBorder : T.value.ev.inputBorderHover,
    }));

    return { T, root, open, muted, selected_label, pick, field };
  },
});
